<template lang='pug'>
	.headerImageShortfull
		.contenedor-headerImageShort
			.contenido
				.modulo.modulo-1
					h2.caja-texto1
						| Title 24 Reports-Full Service Consulting
</template>
<script>
export default {
	name: 'imageShort'
}
</script>



// WEBPACK FOOTER //
// src/components/full/headerImageShort.vue